import createWrappedField from 'ddiForm/wrapped/createWrappedField'
import IS from '../../components/SerialNumberSearchMobile'

export default createWrappedField({
  Component: IS,
  name: 'DDISerialNumberSearchMobile'
})
